import { createAction } from 'redux-actions';

export const Actions = {
  OPEN_JOB_SHARE_MODAL: 'glints/jobShareModal/OPEN_JOB_SHARE_MODAL',
  CLOSE_JOB_SHARE_MODAL: 'glints/jobShareModal/CLOSED_JOBS_SHARE_MODAL',
};

export const openJobShareModal = createAction(Actions.OPEN_JOB_SHARE_MODAL);
export const closeJobShareModal = createAction(Actions.CLOSE_JOB_SHARE_MODAL);
